import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_3 = { class: "dialog-footer" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("确 定")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("取 消")

import { ref, reactive } from 'vue'
import { ElMessage, ElMessageBox, ElForm, ElTable } from 'element-plus'
import { Search, Refresh } from '@element-plus/icons-vue'
import { unallocatedUserList, authUserSelectAll } from "@/service/main/system/role"

// 自定义类型
interface IResponseData<T = any> {
  rows: T[]
  total: number
  msg?: string
}

interface IUserInfo {
  userId: string | number
  userName: string
  nickName: string
  email: string
  phonenumber: string
  status: string
  createTime: string
  [key: string]: any
}

// 解析时间函数

export default /*#__PURE__*/_defineComponent({
  __name: 'selectUser',
  props: {
  // 角色编号
  roleId: {
    type: [Number, String],
    default: undefined
  }
},
  emits: ['ok'],
  setup(__props, { expose, emit }) {

const props = __props

const parseTime = (time: string) => {
  if (time) {
    return new Date(time).toLocaleString()
  }
  return ''
}

// 字典数据
const sysNormalDisable = ref<Array<{label: string, value: string}>>([
  { label: '正常', value: '0' },
  { label: '停用', value: '1' }
])





// 遮罩层
const visible = ref(false)
// 选中数组值
const userIds = ref<Array<string | number>>([])
// 总条数
const total = ref(0)
// 未授权用户数据
const userList = ref<IUserInfo[]>([])

// 查询参数
const queryParams = reactive({
  pageNum: 1,
  pageSize: 10,
  roleId: undefined as string | number | undefined,
  userName: undefined as string | undefined,
  phonenumber: undefined as string | undefined
})

// 表单引用
const queryFormRef = ref<InstanceType<typeof ElForm>>()
const tableRef = ref<InstanceType<typeof ElTable>>()

// 显示弹框
const show = () => {
  queryParams.roleId = props.roleId
  getList()
  visible.value = true
}

const clickRow = (row: IUserInfo) => {
  tableRef.value?.toggleRowSelection(row)
}

// 多选框选中数据
const handleSelectionChange = (selection: IUserInfo[]) => {
  userIds.value = selection.map(item => item.userId)
}

// 查询表数据
const getList = () => {
  unallocatedUserList(queryParams).then(res => {
    const data = res as unknown as IResponseData<IUserInfo>
    userList.value = data.rows
    total.value = data.total
  })
}

/** 搜索按钮操作 */
const handleQuery = () => {
  queryParams.pageNum = 1
  getList()
}

/** 重置按钮操作 */
const resetQuery = () => {
  if (queryFormRef.value) {
    queryFormRef.value.resetFields()
  }
  handleQuery()
}

// 分页处理
const handleSizeChange = (val: number) => {
  queryParams.pageSize = val
  getList()
}

const handleCurrentChange = (val: number) => {
  queryParams.pageNum = val
  getList()
}

/** 选择授权用户操作 */
const handleSelectUser = () => {
  const roleId = queryParams.roleId
  const userIdsStr = userIds.value.join(",")
  if (userIdsStr === "") {
    ElMessage.error("请选择要分配的用户")
    return
  }
  authUserSelectAll({ roleId: roleId, userIds: userIdsStr }).then(res => {
    const data = res as unknown as IResponseData
    ElMessage.success(data.msg || "操作成功")
    visible.value = false
    emit("ok")
  })
}

// 暴露方法给父组件调用
expose({
  show
})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_dict_tag = _resolveComponent("dict-tag")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: "选择用户",
    modelValue: visible.value,
    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((visible).value = $event)),
    width: "800px",
    top: "5vh",
    "append-to-body": ""
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: handleSelectUser
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          onClick: _cache[5] || (_cache[5] = ($event: any) => (visible.value = false))
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(ElForm), {
        model: queryParams,
        ref_key: "queryFormRef",
        ref: queryFormRef,
        size: "default",
        inline: true
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "用户名称",
            prop: "userName"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: queryParams.userName,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((queryParams.userName) = $event)),
                placeholder: "请输入用户名称",
                clearable: "",
                onKeyup: _withKeys(handleQuery, ["enter"])
              }, null, 8, ["modelValue", "onKeyup"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "手机号码",
            prop: "phonenumber"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: queryParams.phonenumber,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((queryParams.phonenumber) = $event)),
                placeholder: "请输入手机号码",
                clearable: "",
                onKeyup: _withKeys(handleQuery, ["enter"])
              }, null, 8, ["modelValue", "onKeyup"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "primary",
                icon: _unref(Search),
                onClick: handleQuery
              }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              }, 8, ["icon"]),
              _createVNode(_component_el_button, {
                icon: _unref(Refresh),
                onClick: resetQuery
              }, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              }, 8, ["icon"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"]),
      _createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          _createVNode(_unref(ElTable), {
            onRowClick: clickRow,
            ref_key: "tableRef",
            ref: tableRef,
            data: userList.value,
            onSelectionChange: handleSelectionChange,
            height: "260px"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                type: "selection",
                width: "55"
              }),
              _createVNode(_component_el_table_column, {
                label: "用户名称",
                prop: "userName",
                "show-overflow-tooltip": true
              }),
              _createVNode(_component_el_table_column, {
                label: "用户昵称",
                prop: "nickName",
                "show-overflow-tooltip": true
              }),
              _createVNode(_component_el_table_column, {
                label: "邮箱",
                prop: "email",
                "show-overflow-tooltip": true
              }),
              _createVNode(_component_el_table_column, {
                label: "手机",
                prop: "phonenumber",
                "show-overflow-tooltip": true
              }),
              _createVNode(_component_el_table_column, {
                label: "状态",
                align: "center",
                prop: "status"
              }, {
                default: _withCtx((scope) => [
                  _createVNode(_component_dict_tag, {
                    options: sysNormalDisable.value,
                    value: scope.row.status
                  }, null, 8, ["options", "value"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "创建时间",
                align: "center",
                prop: "createTime",
                width: "180"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("span", null, _toDisplayString(parseTime(scope.row.createTime)), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"]),
          _withDirectives(_createVNode(_component_el_pagination, {
            total: total.value,
            "onUpdate:total": _cache[2] || (_cache[2] = ($event: any) => ((total).value = $event)),
            "current-page": queryParams.pageNum,
            "onUpdate:current-page": _cache[3] || (_cache[3] = ($event: any) => ((queryParams.pageNum) = $event)),
            "page-size": queryParams.pageSize,
            "onUpdate:page-size": _cache[4] || (_cache[4] = ($event: any) => ((queryParams.pageSize) = $event)),
            "page-sizes": [10, 20, 50, 100],
            layout: "total, sizes, prev, pager, next, jumper",
            onSizeChange: handleSizeChange,
            onCurrentChange: handleCurrentChange
          }, null, 8, ["total", "current-page", "page-size"]), [
            [_vShow, total.value > 0]
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})